export default __webpack_public_path__ + "static/media/_MG_7895.cb8bdbf5.jpg";